import { IconsEnum } from '../../../../../assets/icons/types';
import { ClassName, I18nText } from '../../../../../types';
import {
  OperationClientID,
  FetchOperationsCacheKey
} from '../../../operationsTypes';

import { useToastNotification } from '../../../../../common/hooks/useToastNotification';
import { useWarningForm } from '../../forms/WarningForm/hooks/useWarningForm';

import { WarningForm } from '../../forms/WarningForm';

import { AlertMessage } from '../../../../../helpers/AlertMessage';
import { FormModalButton } from '../../../../../helpers/buttons/FormModalButton';

import { operationsKeys, words } from '../../../../../locales/keys';

const WARNING_FORM = 'warning-form';
const WARNING_BUTTON = 'warning-button';

interface WarningModalButtonProps {
  clientId: OperationClientID;
  cacheKeys?: FetchOperationsCacheKey[];
  className?: ClassName;
  i18nText?: I18nText;
  i18nTextClassName?: ClassName;
  icon?: IconsEnum;
  iconClassName?: ClassName;
  withToastOnSuccess?: boolean;
  disabled?: boolean;
}

function WarningModalButton({
  clientId,
  cacheKeys,
  className,
  i18nText,
  i18nTextClassName,
  icon,
  iconClassName,
  withToastOnSuccess,
  disabled
}: WarningModalButtonProps) {
  const { showToastI18nNotification } = useToastNotification({
    appearance: 'success',
    i18nMessage: operationsKeys.recordAdded
  });

  const {
    validationErrors,
    registerFields,
    handleWarning,
    resetWarningForm,
    createOperationReset,
    createOperationLoading,
    createOperationErrorMessage,
    control
  } = useWarningForm({
    cacheKeys,
    clientId,
    onSuccess: withToastOnSuccess ? showToastI18nNotification : undefined
  });

  return (
    <FormModalButton
      className={className}
      form={WARNING_FORM}
      dataGa={WARNING_BUTTON}
      i18nTitle={operationsKeys.warning}
      i18nText={i18nText || words.create}
      i18nTextClassName={i18nTextClassName}
      i18nSubmitText={operationsKeys.addRecord}
      icon={icon}
      iconClassName={iconClassName}
      onOpen={resetWarningForm}
      isLoading={createOperationLoading}
      onClose={createOperationReset}
      onSubmit={handleWarning}
      disabled={disabled}
    >
      <WarningForm
        form={WARNING_FORM}
        isLoading={createOperationLoading}
        control={control}
        registerSubject={registerFields.registerSubject}
        subjectValidationError={validationErrors.subjectValidationError}
        bodyValidationError={validationErrors.bodyValidationError}
        dateValidationError={validationErrors.dateValidationError}
        completeDatetimeValidationError={
          validationErrors.completeDatetimeValidationError
        }
      />

      <div className="px-4">
        <AlertMessage message={createOperationErrorMessage} />
      </div>
    </FormModalButton>
  );
}

export default WarningModalButton;
